






























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { Popover } from 'element-ui';
import { namespace } from 'vuex-class';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;
export interface TaskEditType { // 编辑结构类型
  group_name: string;
}

@Component({
  components: {
    AcgnPop,
    [Popover.name]: Popover
  }
})
export default class AcgnAddGroup extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public eidtGroupName: any; // 编辑任务名称
  @Prop() public groupId: any; // 编辑任务名称
  @Prop() public comicId: any; // 项目id
  @Prop() public groupList: any; // 刷新任务列表
  @TaskGroupAction private createTaskGroup: any; // 创建任务
  @TaskGroupAction private eidtTaskGroup: any; // 编辑任务组
  @TaskGroupGetter private loadings: any; // 任务组loading
  private formData: TaskEditType = {
    group_name: ''
  };
  @Watch('visible')
  private getVisible() {
    this.formData = {
      group_name: this.eidtGroupName
    };
  }

  get show() {
    return this.visible;
  }

  set show(v) {
    this.$emit('update:visible', v);
  }

  // 提交任务组
  private async submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        if (this.eidtGroupName) {
          const params = { ...this.formData, project_id: this.comicId, group_id: this.groupId };
          await this.eidtTaskGroup(params);
          this.$message.success('编辑任务组成功');
        } else {
          const params = { ...this.formData, project_id: this.comicId };
          await this.createTaskGroup(params);
          this.$message.success('创建任务组成功');
        }
        this.groupList();
        this.show = false;
      } catch (ex) {
        this.$message.error(ex.message);
      }
    });
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      group_name: [
        { required: true, message: '请输入任务组名称', trigger: 'blur' }
      ]
    };
    return rules;
  }
}
